import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { SectorLocationService } from 'src/app/shared/API-Service/services/sector-location.service';
import { SectorTypeService } from 'src/app/shared/API-Service/services/sector-type.service';
import { KeywordsService } from 'src/app/shared/API-Service/services/keywords.service';
import { timestamp } from 'rxjs/operators';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-insert-sector-location',
  templateUrl: './insert-sector-location.component.html',
  styleUrls: ['./insert-sector-location.component.css']
})
export class InsertSectorLocationComponent implements OnInit {
  keyword:object [] = [];
  selectedItems:any = [];
  numbers:any [] = [];
  dropdownSettings: any = {};
  recordtoupdate: any;
  sectortype: any;
  sectorlocationForm : FormGroup;
 sectorlocationFormData : FormData;
 update:boolean = false;
 button:boolean = false;
  constructor(private _SectorLocationService:SectorLocationService,private _Router:Router,private _FormBuilder:FormBuilder,
    private _SectorTypeService:SectorTypeService,private _KeywordsService:KeywordsService) { }

  ngOnInit(): void {
    this.getsectortype();
    this.getkeywords();
    this.initiate();
    this.checkEdit();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'title',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
  }
  getsectortype(){
    this._SectorTypeService.GetSectorType().subscribe((res) => {
      this.sectortype = res.data;
    },(err) => {
      console.log('thier is an error');
    },() => {
      console.log('completed');
    })
  }
  initiate(){
    this.sectorlocationForm = this._FormBuilder.group({
      title: ['', Validators.required],

      sectorTypeId: ['', Validators.required],
    });
  }
  get fc() {
    return this.sectorlocationForm.controls;
  }
  checkEdit() {
    this._SectorLocationService.Data.subscribe((res) => {
      if (res != null) {
        this.selectedItems = res.keywordsNames;
        this.selectedItems.forEach(element => {
          this.numbers.push(element.id);
        });
        this.sectorlocationForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          keyword: [this.selectedItems],
          sectorTypeId: [res.sectorTypeId, Validators.required],
        });
       
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  getkeywords(){
    this._KeywordsService.Getkeywords().subscribe((res) => {
      this.keyword = res.data; 
    },(err) => {
     console.log('their is a problem');
    },() => {
     console.log('completed');
    })
   }
   onItemSelect(item: any) {
    this.numbers.push(item.id);
     console.log(this.selectedItems);
 }
 onItemDeSelect(item: any) {
     console.log('onItemDeSelect', item);
  
     const index = this.numbers.indexOf(item.id);
                  if (index > -1) { 
                          this.numbers.splice(index, 1); 
                                     }
     removeItem(item, this.selectedItems);
      
 }
 onSelectAll(items: any) {
     console.log('onSelectAll', items);
        this.numbers = [];
     items.forEach(element => {
      this.numbers.push(element.id);
    });

 }
 onUnSelectAll(items: any) {
  
 this.selectedItems.splice(0);
 this.numbers.splice(0);
  this.numbers = [];
  console.log(this.selectedItems + 'i am the selected items after deslect');
  console.log(this.numbers + 'i am the numbers after deslect');
     console.log('onSelectAll', items);
 }
  onSubmit(){
  
    console.log(this.numbers + 'i am the number ');
    this.button = true;
    this.sectorlocationForm.addControl('keywords', new FormControl(this.numbers));
    console.log(this.sectorlocationForm.value);
   if(this.update == false && this.sectorlocationForm.status == "VALID"){
    this._SectorLocationService.CreateSectorLocation(this.sectorlocationForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.sectorlocationForm.reset();
      this._Router.navigate(['/content/admin/ViewSectorLocation']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.sectorlocationForm.status == "VALID"){
   
    this.sectorlocationForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._SectorLocationService.UpdateSectorLocation(this.sectorlocationForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.sectorlocationForm.reset();
      this._Router.navigate(['/content/admin/ViewSectorLocation']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.sectorlocationForm.markAllAsTouched();
    this.button = false;
   }

  }


  ngOnDestroy(){
    this._SectorLocationService.Data.next(null);
     }
}
function removeItem(item: any, selectedItems: any) {
  throw new Error('Function not implemented.');
}

